define('home/views/ForumCoverView',[
    'backbone-marionette',
    'home/models/Session',

    'home/templates/forumCover',
], function (
    Marionette,
    Session,

    forumCoverTemplate
) {
    'use strict';

    /**
     * The cover portion of a forum feed page. Shows forum details
     * and supports forum actions, such as (un)follow.
     */
    var ForumCoverView = Marionette.ItemView.extend({
        template: forumCoverTemplate,
        templateHelpers: function () {
            return {
                friendlyUrl: this.model.getFriendlyUrl(),
                plainDescription: this.model.getPlainDescription(),
            };
        },

        events: {
            'click [data-action=toggle-follow]': 'toggleFollow',
        },
        modelEvents: {
            'change:name': 'render',
            'change:isFollowing': 'handleFollowedClass',
        },

        initialize: function () {
            this.session = Session.get();
            this.listenTo(this.session, 'setModeratedForums', this.render);
        },

        handleFollowedClass: function () {
            this.$('[data-action=toggle-follow]').toggleClass('active', this.model.get('isFollowing'));
        },

        toggleFollow: function (evt) {
            if (evt)
                evt.preventDefault();

            this.model.toggleFollowed();
        },
    }, {
        /**
         * Used to chose the correct model for this view.
         * If the given model has a related forum, returns
         * that forum. Otherwise assumes that the given model
         * is a forum and passes it through.
         *
         * @param  {Model} model - A model that is a forum or has
         *                         a related forum.
         * @returns {Forum}       - A forum model, as this view expects
         *                         to be initialized with.
         */
        getModel: function (model) {
            return model.forum || model;
        },
    });

    return ForumCoverView;
});

